<div class="row">
    <div class="col-4">
        <sb-card [loading]="loading">
            <div card-header>
                {{'lang.userEdit.userDetails' | translate}}
            </div>
            <div card-body>
                <form [formGroup]="form" (ngSubmit)="updateUser()">
                    <div class="form-group">
                        <label class="form-label" for="email">{{'lang.globals.email' | translate}}</label>
                        <input name="email" type="email" id="email" class="form-control" formControlName="Email"
                               [attr.disabled]="userId  ? 'disabled' : null"
                               [ngModel]="user?.user?.email" (ngModelChange)="setUserInfo('email', $event)">
                      <div *ngIf="Email.dirty && Email.errors?.required"
                             class="alert alert-danger">{{'lang.globals.emailRequest' | translate}}</div>
                    </div>
                    <div class="form-group">
                        <label class="form-label" for="firstname">{{'lang.globals.firstName' | translate}}</label>
                        <input name="firstname" type="text" id="firstname" class="form-control" formControlName="Firstname"
                               [attr.disabled]="user?.user?.id ? 'disabled' : null" [ngModel]="user?.user?.firstname"
                               (ngModelChange)="setUserInfo('firstname', $event)">
                      <div *ngIf="Firstname.dirty && Firstname.errors?.required"
                             class="alert alert-danger">{{'lang.globals.firstNameRequest' | translate}}</div>
                    </div>
                    <div class="form-group">
                        <label class="form-label" for="lastname">{{'lang.globals.lastName' | translate}}</label>
                        <input name="lastname" type="text" id="lastname" class="form-control" formControlName="Lastname"
                               [attr.disabled]="user?.user?.id ? 'disabled' : null" [ngModel]="user?.user?.lastname"
                               (ngModelChange)="setUserInfo('lastname', $event)">
                      <div *ngIf="Lastname.dirty && Lastname.errors?.required"
                             class="alert alert-danger">{{'lang.globals.lastNameRequest' | translate}}</div>
                    </div>
                </form>
                <div *ngIf="!user?.client">
                    <sb-boolean-toggles class="mr-1" [toggles]="initialBooleans"
                                        (toggleChange)="boolChange($event?.id, $event?.value)">

                        Welcome Mail
                    </sb-boolean-toggles>
                </div>

                <div *ngIf="user?.client" class="row">
                    <div class="col-md-6">
            <span *ngIf="user?.blocked" class="red font-weight-bold"> <sb-icon icon="error"></sb-icon>
                {{ 'lang.globals.blocked' | translate }} ({{user?.blocked?.toString() | date : 'dd.MM.yyyy HH:mm'}}
                )</span>
                        <span *ngIf="!user?.blocked" class="green font-weight-bold"> <sb-icon icon="success"></sb-icon>
                            {{ 'lang.globals.active' | translate }}</span>
                    </div>
                    <div class="col-md-6 d-flex justify-content-end">
                        <ng-container *ngPermissions="[permissionService.Permission.client_user_block]">
                            <button *ngIf="!user?.blocked" (click)="toggleUserStatus()" class="btn btn-danger">
                                <sb-icon icon="error"></sb-icon>
                                {{ 'lang.userEdit.blockUser' | translate }}
                            </button>
                        </ng-container>
                        <ng-container *ngPermissions="[permissionService.Permission.client_user_unblock]">
                            <button *ngIf="user?.blocked" (click)="toggleUserStatus()" class="btn btn-success">
                                <sb-icon icon="success"></sb-icon>
                                {{ 'lang.userEdit.unblockUser' | translate }}
                            </button>
                        </ng-container>
                    </div>
                </div>
                <div *ngIf="user?.lastLogin" class="col-md-6">
                    <p class="m-0"> {{ 'lang.userEdit.lastLogin' | translate }}</p>
                    <p> {{user?.lastLogin?.toString() | date: 'dd.MM.yy HH:mm:ss'}}</p>
                </div>
            </div>
        </sb-card>
    </div>
    <div class="col-4" *ngIf="user?.client">
        <sb-card [loading]="loading || rolesLoading">
            <div card-header>
                <sb-search-bar
                        placeholder="{{ 'lang.globals.searchPlaceholder' | translate }}"
                        searchTooltip="{{ 'lang.globals.searchPlaceholder' | translate }}"
                        stopSearchTooltip="{{ 'lang.globals.stopSearchPlaceholder' | translate }}"
                        (searchAction)="roleSearchChanged($event)"
                        headline="{{ 'lang.headlines.roles' | translate }}"
                        [searchStr]="roleSearch"></sb-search-bar>
            </div>
            <div card-body>
                <form [formGroup]="formRoles" (ngSubmit)="updateUser()">
                    <ng-container *ngIf="user?.client">
                        <div style="padding-left: 0">
                            <ng-container *ngIf="!loading">
                                <ng-scrollbar style="height: 445px;">
                                    <ng-container *ngFor="let r of displayedRoles">
                                        <div class="form-check form-switch ml-2">
                                            <input type="checkbox" role="switch" class="form-check-input"
                                                   [id]=r.name [formControlName]=r.name (ngModelChange)="updateRoles(r, $event)">
                                            <label class="form-check-label" [for]=r.name>{{r.name | sbDefaultRoleTranslate}}</label>
                                        </div>
                                    </ng-container>
                                </ng-scrollbar>
                            </ng-container>
                        </div>
                    </ng-container>
                </form>
            </div>
        </sb-card>
    </div>
    <div class="col-4" *ngIf="user?.client">
        <sb-card [loading]="loading">
            <div card-header>
                <sb-search-bar
                        placeholder="{{ 'lang.globals.searchPlaceholder' | translate }}"
                        searchTooltip="{{ 'lang.globals.searchPlaceholder' | translate }}"
                        stopSearchTooltip="{{ 'lang.globals.stopSearchPlaceholder' | translate }}"
                        (searchAction)="onPermissionSearch($event)"
                        headline="{{ 'lang.globals.directPermissions' | translate }}"
                        [searchStr]="permissionSearch"></sb-search-bar>

            </div>
            <div card-body>
                <div class="row">
                    <div class="col-6">
                        <a class="w-100 btn btn-success" (click)="selectAllPermissions()">
                            {{'lang.globals.selectAll' | translate}}
                        </a>
                    </div>
                    <div class="col-6">
                        <a class="w-100 btn btn-danger" (click)="selectNoPermissions()">
                            {{'lang.globals.deselectAll' | translate}}
                        </a>
                    </div>
                </div>
                <form [formGroup]="formPermissions" (ngSubmit)="updateUser()" class="mt-2">
                    <ng-container *ngIf="user?.client">
                        <div style="padding-left: 0;">
                            <ng-container *ngIf="!loading">
                                <ng-scrollbar style="height: 400px;">
                                    <ng-container *ngFor="let c of displayedPermissions?.sort()">
                                        <div class="form-check form-switch online ml-2">
                                            <input type="checkbox" role="switch" class="form-check-input"
                                                   [id]=c [formControlName]=c [checked]="hasExplicitPermission(c)"
                                                   (ngModelChange)="updateUserPermissions(c, $event)">
                                            <label class="form-check-label" [for]=c>
                                                <ng-container *ngIf="hasEffectivePermission(c)"><b
                                                        class="green">{{c | sbPermissionTranslate}}</b></ng-container>
                                                <ng-container
                                                        *ngIf="!hasEffectivePermission(c)">{{c | sbPermissionTranslate}}</ng-container>
                                            </label>
                                        </div>
                                    </ng-container>
                                </ng-scrollbar>
                            </ng-container>
                        </div>
                    </ng-container>
                </form>
            </div>
        </sb-card>
    </div>
</div>


<div class="modal-footer">
    <sb-button classes="btn-default" (click)="close(false)">{{ 'lang.globals.cancel' | translate }}</sb-button>
    <sb-button classes="btn-primary" (click)="updateUser()"
               [disabled]="!form.valid || loading || waitingForServerResponse">{{ (user?.client ? 'lang.globals.save' : 'lang.globals.create') | translate }}</sb-button>
</div>

